import * as React from 'react';

export interface RangeProps {
  children?: React.ReactNode;
  dataHook?: string;
}

export default class Range extends React.Component<RangeProps> {}
